import {browserHistory} from 'react-router';

export default {
    pushState: (state, path) => {
        browserHistory.push(path, state);
    },
    push: browserHistory.push,
    replace: browserHistory.replace,
    go: browserHistory.go,
    goBack: browserHistory.goBack,
    goForward: browserHistory.goForward,
    browserHistory
};

/**
 * @export
 * @param {string} inviteId
 * @return {*}
 */
export function goToSubmitGenericContent(inviteId) {
    return browserHistory.push(`/creator/dashboard/campaigns/${inviteId}/submit_generic_content`);
}

export function goToDashboard() {
    return browserHistory.push('/creator/dashboard');
}

export function goToLogin() {
    return browserHistory.push('/creator/login');
}

export function goToDashboardProfile() {
    return browserHistory.push('/creator/dashboard/profile');
}



// WEBPACK FOOTER //
// ./creator/history.js